@if ({ trialTasks: (trialTasks$ | async) || [] }; as obj) {
  <div
    #trigger="cdkOverlayOrigin"
    class="flex cursor-pointer items-center px-4 text-sm text-white"
    cdkOverlayOrigin
    [ngClass]="{ 'bg-aux-gray-light text-aux-blue': isOpen }"
    (click)="toggleOpenList(!isOpen)"
    (auxClickOutside)="toggleOpenList(false)"
  >
    <aux-icon name="Checkbox" />
    <span class="mx-5px">Tasks</span>
    @if (obj.trialTasks.length) {
      <span
        class="flex h-8 w-8 items-center justify-center rounded-full border border-aux-blue bg-aux-gray-light font-bold text-aux-blue"
      >
        <span>{{ obj.trialTasks.length }}</span>
      </span>
    }
  </div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
  >
    @if (trialTasks$ | async; as trialTasks) {
      <aux-portfolio-task-list
        class="overflow-y-scroll border-l border-aux-gray-dark bg-white shadow"
        style="width: 400px; max-height: 420px"
        [tasks]="trialTasks"
        [noTasksMessage]="noMessage"
        [ngStyle]="{ height: obj.trialTasks.length ? 'auto' : '420px' }"
      />
    }
  </ng-template>
}
